import assertNever from 'assert-never';

import { DeviceBluetoothPower } from '@shure/shared/angular/data-access/system-api/models';

import { BluetoothPower } from '../graphql/generated/cloud-sys-api';

export function mapBluetoothPowerFromSysApi(level?: BluetoothPower): DeviceBluetoothPower | undefined {
	switch (level) {
		case BluetoothPower.Low:
			return DeviceBluetoothPower.Low;
		case BluetoothPower.Medium:
			return DeviceBluetoothPower.Medium;
		case BluetoothPower.High:
			return DeviceBluetoothPower.High;
		case undefined:
			return undefined;
		default:
			assertNever(level);
	}
}

export function mapDeviceBluetoothPowerToSysApi(level: DeviceBluetoothPower): BluetoothPower {
	switch (level) {
		case DeviceBluetoothPower.Low:
			return BluetoothPower.Low;
		case DeviceBluetoothPower.Medium:
			return BluetoothPower.Medium;
		case DeviceBluetoothPower.High:
			return BluetoothPower.High;
		default:
			assertNever(level);
	}
}
